export const LOGIN_KEY = "LOGIN_KEY";
export const WELCOME_ROUTES = ["/login"];
export const NO_BACK_ROUTES = ["/dashboard", "/login"];

export const US_STATES = [
  {
    label: "Alabama",
    value: "AL"
  },
  {
    label: "Alaska",
    value: "AK"
  },
  {
    label: "American Samoa",
    value: "AS"
  },
  {
    label: "Arizona",
    value: "AZ"
  },
  {
    label: "Arkansas",
    value: "AR"
  },
  {
    label: "California",
    value: "CA"
  },
  {
    label: "Colorado",
    value: "CO"
  },
  {
    label: "Connecticut",
    value: "CT"
  },
  {
    label: "Delaware",
    value: "DE"
  },
  {
    label: "District Of Columbia",
    value: "DC"
  },
  {
    label: "Federated States Of Micronesia",
    value: "FM"
  },
  {
    label: "Florida",
    value: "FL"
  },
  {
    label: "Georgia",
    value: "GA"
  },
  {
    label: "Guam",
    value: "GU"
  },
  {
    label: "Hawaii",
    value: "HI"
  },
  {
    label: "Idaho",
    value: "ID"
  },
  {
    label: "Illinois",
    value: "IL"
  },
  {
    label: "Indiana",
    value: "IN"
  },
  {
    label: "Iowa",
    value: "IA"
  },
  {
    label: "Kansas",
    value: "KS"
  },
  {
    label: "Kentucky",
    value: "KY"
  },
  {
    label: "Louisiana",
    value: "LA"
  },
  {
    label: "Maine",
    value: "ME"
  },
  {
    label: "Marshall Islands",
    value: "MH"
  },
  {
    label: "Maryland",
    value: "MD"
  },
  {
    label: "Massachusetts",
    value: "MA"
  },
  {
    label: "Michigan",
    value: "MI"
  },
  {
    label: "Minnesota",
    value: "MN"
  },
  {
    label: "Mississippi",
    value: "MS"
  },
  {
    label: "Missouri",
    value: "MO"
  },
  {
    label: "Montana",
    value: "MT"
  },
  {
    label: "Nebraska",
    value: "NE"
  },
  {
    label: "Nevada",
    value: "NV"
  },
  {
    label: "New Hampshire",
    value: "NH"
  },
  {
    label: "New Jersey",
    value: "NJ"
  },
  {
    label: "New Mexico",
    value: "NM"
  },
  {
    label: "New York",
    value: "NY"
  },
  {
    label: "North Carolina",
    value: "NC"
  },
  {
    label: "North Dakota",
    value: "ND"
  },
  {
    label: "Northern Mariana Islands",
    value: "MP"
  },
  {
    label: "Ohio",
    value: "OH"
  },
  {
    label: "Oklahoma",
    value: "OK"
  },
  {
    label: "Oregon",
    value: "OR"
  },
  {
    label: "Palau",
    value: "PW"
  },
  {
    label: "Pennsylvania",
    value: "PA"
  },
  {
    label: "Puerto Rico",
    value: "PR"
  },
  {
    label: "Rhode Island",
    value: "RI"
  },
  {
    label: "South Carolina",
    value: "SC"
  },
  {
    label: "South Dakota",
    value: "SD"
  },
  {
    label: "Tennessee",
    value: "TN"
  },
  {
    label: "Texas",
    value: "TX"
  },
  {
    label: "Utah",
    value: "UT"
  },
  {
    label: "Vermont",
    value: "VT"
  },
  {
    label: "Virgin Islands",
    value: "VI"
  },
  {
    label: "Virginia",
    value: "VA"
  },
  {
    label: "Washington",
    value: "WA"
  },
  {
    label: "West Virginia",
    value: "WV"
  },
  {
    label: "Wisconsin",
    value: "WI"
  },
  {
    label: "Wyoming",
    value: "WY"
  }
];

export const STATUS_TYPES = {
  WAITING_FOR_CLIENT_INFO: "WAITING_FOR_CLIENT_INFO",
  WAITING_FOR_APPROVAL: "WAITING_FOR_APPROVAL",
  CLIENT_APPROVED: "CLIENT_APPROVED",
  DATA_NEEDED: "DATA_NEEDED",
  SUBMITTED_TO_UNDERWRITING: "SUBMITTED_TO_UNDERWRITING",
  QUOTE_AVAILABLE: "QUOTE_AVAILABLE"
};

export const DASHBOARD_STATUS_LABEL = {
  WAITING_FOR_CLIENT_INFO: "Waiting on client info",
  WAITING_FOR_APPROVAL: "Waiting on approval",
  CLIENT_APPROVED: "Client Approved",
  DATA_NEEDED: "Data needed",
  SUBMITTED_TO_UNDERWRITING: "Underwriting Approval",
  QUOTE_AVAILABLE: "Approved"
};

export const DASHBOARD_STATUS_ROUTING = {
  WAITING_FOR_CLIENT_INFO: {
    label: "i",
    route: null
  },
  WAITING_FOR_APPROVAL: {
    label: "i",
    route: null
  },
  CLIENT_APPROVED: {
    label: "Continue",
    route: "/details/{id}"
  },
  DATA_NEEDED: {
    label: "View",
    route: "/details-needed/{id}"
  },
  SUBMITTED_TO_UNDERWRITING: {
    label: "i",
    route: null
  },
  QUOTE_AVAILABLE: {
    label: "View",
    route: "/approved-details/{id}"
  }
};

export const DASHBOARD_STATUS_ICONS = {
  WAITING_FOR_CLIENT_INFO: "WAITING",
  WAITING_FOR_APPROVAL: "EMAIL",
  CLIENT_APPROVED: "OK",
  DATA_NEEDED: "EDIT",
  SUBMITTED_TO_UNDERWRITING: "APPROVED",
  QUOTE_AVAILABLE: "APPROVED"
};

export const INFO_MODAL_CONTENT = {
  WAITING_FOR_CLIENT_INFO: {
    title: "Waiting for Client Info",
    text:
      "We have sent the client an email form with additional information we need in order to proceed."
  },
  WAITING_FOR_APPROVAL: {
    title: "Waiting for Approval",
    text:
      "We are waiting for the client to approve that you share their personal information."
  },
  SUBMITTED_TO_UNDERWRITING: {
    title: "Underwriting Approval",
    text:
      "Everything is submitted to the carrier and we are waiting on their underwriting process to approve this client."
  }
};
